export const ADD_MATERIAL_GRID_CODE = 'service-case-order-job-add-material';
